<div class="d-flex flex-column justify-content-center align-items-center">
  <i class="fal fa-trash-alt fz-80 mb-28 color-primary mt-16"></i>
  <p class="fz-18 text-center mb-24 fw-bold" redBlack2>
    ¿Seguro que quieres eliminar este registro?
  </p>
  <div class="d-flex w-100 align-items-center justify-content-center" style="gap: 10px;">
    <div style="max-width: 144px;" class="w-100 mr-2">
      <app-button (click)="cerrarModal()" d-contents background="secondary" type="outline" shape="round" size="large">
        <app-icon>
          <i class="fal fa-chevron-left"></i>
        </app-icon>
        <p title-button>
          Cancelar
        </p>
      </app-button>

    </div>
    <div style="max-width: 144px;" class="w-100 ml-2">

      <app-button (click)="eliminarUsuario()" d-contents background="primary" type="solid" shape="round" size="large">
        <app-icon>
          <i class="fal fa-trash-alt"></i>
        </app-icon>
        <p title-button>
          Eliminar
        </p>
      </app-button>
    </div>
  </div>
</div>
